module.exports = __webpack_public_path__ + "images/jobs/jobs_footer_image.jpg";